import { createScopedInstance, getLanguage } from '@citrite/translate';
import { languages } from '../locales';
export { getLanguage };
var _createScopedInstance = createScopedInstance({
    resources: languages,
    namespace: 'citrix-files-ui'
  }),
  t = _createScopedInstance.t;
export { t };